import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import ErrorIcon from '@material-ui/icons/Error';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core';
import { IInfoCardMessageProps } from './types';
import useStyles from './style';

const InfoCardMessage = ({
  type,
  title,
  subtitle,
  text,
  messages,
}: IInfoCardMessageProps) => {
  const classes = useStyles();

  const Icon = React.useMemo(() => {
    const messageIcons = {
      ERROR: <ErrorIcon aria-label="Erro" />,
      ALERT: <ReportProblemIcon aria-label="Aviso" />,
      SUCCESS: <CheckCircleIcon aria-label="Sucesso" />,
      INFO: <InfoIcon aria-label="Informação" />,
      default: <InfoIcon aria-label="Informação" />,
    };
    return messageIcons[type] || messageIcons.default;
  }, [type]);

  return (
    <div className={classes.container}>
      <div className={classes.titleContainer}>
        {Icon}
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
      </div>

      {subtitle && (
        <Typography variant="subtitle2" className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}

      {text && (
        <Typography variant="body1" className={classes.text}>
          {text}
        </Typography>
      )}

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.heading}>Detalhes:</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {Object.values(messages).map((message, index) => (
            <pre key={index} className={classes.message}>
              {message}
            </pre>
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default InfoCardMessage;
